<template>
  <div class="progress-wrapper">
    <router-link to="/home/premi" class="progress-preview-link">
      <div class="progress-container">
        <div class="progress-label">Progressione</div>
        <div class="progress-bar">
          <div
            class="progress-fill"
            :style="{ width: progressPercentage + '%' }"
          ></div>
        </div>
        <div v-if="utente" class="progress-info">
          {{ utente.crediti_totali_acquistati }} / {{ maxTier }} Coin acquistati
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import axios from "axios";
import { API_BASE_URL } from "../config";

export default {
  name: "ProgressBar",
  data() {
    return {
      studio: null,
      studioSelezionato: null,
      modalUtentiVisibile: false,
      mostraDettagliUtente: false,
      utente: null,
      isLoading: true,
      downloadLogs: [],
      expandedRows: [],
      tiers: [
        { soglia: 0, feature: "Tema base" },
        { soglia: 100, feature: "Tema chiaro/scuro" },
        { soglia: 250, feature: "Sfondi personalizzati" },
        { soglia: 5000, feature: "Icone e animazioni avanzate" },
      ],
    };
  },
  computed: {
    unlockedFeatures() {
      const crediti = this.utente?.crediti_totali_acquistati || 0;
      return this.tiers
        .filter((t) => crediti >= t.soglia)
        .map((t) => t.feature);
    },
    maxTier() {
      return this.tiers[this.tiers.length - 1].soglia;
    },
    progressPercentage() {
      const crediti = this.utente?.crediti_totali_acquistati || 0;
      const p = (crediti / this.maxTier) * 100;
      return Math.min(100, Math.round(p));
    },
  },
  mounted() {
    this.fetchAllData();
    this.fetchUtente();
  },
  methods: {
    fetchUtente() {
      axios
        .get(`${API_BASE_URL}/utente/info_personale`)
        .then((response) => {
          this.utente = response.data;
        })
        .catch((error) => {
          console.error("Errore nel recupero delle info utente:", error);
        });
    },
    async fetchAllData() {
      this.isLoading = true;
      try {
        // Eseguo entrambe le chiamate in parallelo
        const [studioResponse, logsResponse] = await Promise.all([
          axios.get(`${API_BASE_URL}/admin/get_studio_by_admin`),
          axios.get(`${API_BASE_URL}/utente/download_logs`),
        ]);

        // Gestione risposta studio
        this.studio = studioResponse.data.studio;
        if (this.studio && this.studio.id) {
          console.log("Studio caricato correttamente:", this.studio);
        } else {
          console.warn("Studio non valido o privo di ID.");
        }

        // Gestione risposta log
        if (logsResponse.data.success) {
          this.downloadLogs = logsResponse.data.logs;
        } else {
          this.downloadLogs = [];
          console.warn("Nessun log di download disponibile.");
        }
      } catch (error) {
        console.error("Errore nel caricamento dati:", error);
        // Potresti anche qui resettare o pulire dati in caso di errore
        this.studio = null;
        this.downloadLogs = [];
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
<style scoped>
.progress-wrapper {
  position: absolute;
  top: 0; /* distanza dall'alto */
  right: 0; /* distanza dal bordo destro */
  z-index: 10; /* sopra altri elementi */
}
.progress-container {
  width: 180px;
  background: #f7f7f7;
  padding: 0.6rem 1rem;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease;
}

.progress-preview-link {
  text-decoration: none;
  color: inherit;
}

.progress-container:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.progress-label {
  font-weight: bold;
  margin-bottom: 4px;
  font-size: 0.9rem;
}

.progress-bar {
  width: 100%;
  background: #ddd;
  height: 16px;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 4px;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(to right, #4caf50, #8bc34a);
  transition: width 0.5s ease;
}

.progress-info {
  font-size: 0.85rem;
  text-align: right;
  color: #444;
}
</style>
